import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MFileUploadService {
  private progressSource = new Subject<number>();
  progressUpdate = this.progressSource.asObservable();

  updateProgress(progress: number) {
    this.progressSource.next(progress);
  }
}
